import { useState } from "react"
import { buildImageSrcSet } from "./imageSrcSet"

// Image column of admin listing cards: the CDN image when set, otherwise a
// picture-icon placeholder so every card keeps the with-img layout.
// placeholderAspect shapes the placeholder box only (a real image keeps its
// own proportions): 4:3 default for sku cards, 16:9 for product rows.
export default function CardImage({ imageUrl, availableWidths, alt, placeholderAspect = "4 / 3" }: {
  imageUrl?: string
  availableWidths?: number[]
  alt: string
  placeholderAspect?: string
}) {
  // Right after an upload the scaler hasn't produced the width variants yet,
  // so the srcset-picked one can 404 while the original already exists —
  // retry with the original alone (per-URL, so a later image_url gets its
  // srcset back).
  const [fallbackUrl, setFallbackUrl] = useState<string | null>(null)
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        srcSet={fallbackUrl === imageUrl ? undefined : buildImageSrcSet(imageUrl, availableWidths)}
        sizes="120px"
        alt={alt}
        className="license-group-img"
        onError={() => setFallbackUrl(imageUrl)}
      />
    )
  }
  return (
    <div className="license-group-img license-group-img-placeholder" style={{ aspectRatio: placeholderAspect }} aria-hidden="true">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="var(--nfa-middle-grey)">
        <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
      </svg>
    </div>
  )
}
